// @ts-nocheck
import React from 'react';
import intl from 'react-intl-universal';
import classNames from 'classnames';
import styled from 'styled-components';
import { Tabs, Tab } from '@blueprintjs/core';

import { Card } from '@/components';
import { CLASSES } from '@/constants/classes';
import CarriersList from './CarriersList';
import '@/style/pages/Preferences/Carriers.scss';

export default function PreferencesCarriersPage() {
  const onChangeTabs = () => {};

  return (
    <div
      className={classNames(
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT,
        CLASSES.PREFERENCES_PAGE_INSIDE_CONTENT_CARRIERS,
      )}
    >
       <CarriersCard>
        <CarriersList />
      </CarriersCard>
    </div>
  );
}

const CarriersCard = styled(Card)`
  padding: 0;
`;
